<div class="row event-info-wrapper campaign-image">
  <img class="event-image" [src]="getImageUrl(option)"/>
</div>

<div class="row event-info-wrapper">
  <div class="col-8 current-name-text">
    <div class="option-name"> {{ option.name }}  </div>
  </div>
  <div class="col-4 text-right current-option-amount">
    <div class="title-text"> Value</div>
    <div class="current-name-text"> {{ option.amount | currency:'USD':'symbol-narrow':'1.0-0' }} </div>
  </div>
</div>

<div class="widget__separator"></div>

<div class="row event-info-wrapper" *ngIf="isNotEmpty(campaign)">
  <div class="col-8 col-wrapper">
    <div class="title-text">Campaign</div>
    <div class="current-name-text"> {{ campaign.name }} </div>
  </div>

  <div class="col-4 text-right col-wrapper">
    <div class="title-text">Raised</div>
    <div class="current-name-text"> {{ raised | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
  </div>
</div>

<div class="widget__separator"></div>

<div class="row event-info-wrapper" *ngIf="isNotEmpty(event)">
  <div class="title-text">Event</div>
  <div class="current-name-text"> {{ event.name }} </div>
</div>

<div class="widget__separator"></div>

